'use strict';

const ImageCopyright = (($) => {

    const NAME = 'imageCopyright';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
    }

    class ImageCopyright {

        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;

            this.isMoving = false;
            this.isOpen = false;

            if (!this.isProcessed()) {
                this.addCopyright();
            }

        }


        addCopyright() {
            const copyrightText = this.$element.data('copyright');

            const copyrightLinkHtml = '<a role="button" tabindex="0" class="js-copyright c-image-container__copyright-link" data-tippy-content="' + copyrightText + '" title="Copyright Informationen anzeigen">Copyright</a>';

            // const $parentFigure = this.getParentFigure();
            const $parentFigure = this.$element;

            $parentFigure.children().first().wrap('<div class="c-image-container" />');
            $parentFigure.children().first().append(copyrightLinkHtml);

            this.$element.attr('data-cradded', '1');

            return true;
        }

        isProcessed() {
            return (this.$element.attr('data-cradded') === '1');
        }

        // getParentFigure() {
        //     return this.$element.parents('figure');
        // }

        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    ImageCopyright.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new ImageCopyright(this, _config)
            })
        }
    }

    $.fn[NAME]             = ImageCopyright._jQueryInterface;
    $.fn[NAME].Constructor = ImageCopyright;
    $.fn[NAME].noConflict  = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return ImageCopyright._jQueryInterface
    };

    return ImageCopyright;

})(jQuery);

export default ImageCopyright;